import { Action, AnyAction } from "redux";
import store from "../state/Store";
import Logger from "./Logger";
import { handleError } from "../state/system/Alerts";
import { ThunkAction } from "@reduxjs/toolkit";

export async function unwrappedDispatch<T>(
    action: Action<T> | ThunkAction<T, void, any, Action<T>>,
): Promise<T> {
    try {
        let temp = (store.dispatch(action) as AnyAction).unwrap();

        if (temp instanceof Promise) temp = await temp;

        return temp as T;
    } catch (error) {
        if (Reflect.has(error, "name") && error.name === "ConditionError")
            return null;
        else {
            let message = error;
            if (Reflect.has(error, "message")) message = error.message;

            Logger.error(error);
            store.dispatch(
                handleError({
                    message: `Internal application error, ${message}`,
                    id: "InternalError",
                    reason: "Internal Error",
                }),
            );

            throw error;
        }
    }
}
